var _defs, _path, _g, _g2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.271,75.582H18.739c-.552,0-1-.447-1-1V12.02c0-.552.448-1,1-1h47.449c.553,0,1,.448,1,1v23.587c0,.552-.447,1-1,1s-1-.448-1-1V13.02H19.739v60.562h36.533c.553,0,1,.447,1,1s-.447,1-1,1h-.001Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.394,
    y1: 25.823,
    x2: 50.912,
    y2: 25.823
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.912,26.823h-16.518c-.552,0-1-.448-1-1s.448-1,1-1h16.518c.553,0,1,.448,1,1s-.447,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.552,
    y1: 21.254,
    x2: 50.875,
    y2: 25.577
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.876,26.577c-.256,0-.512-.098-.707-.293l-4.324-4.323c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l4.324,4.323c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.875,
    y1: 25.913,
    x2: 46.552,
    y2: 30.236
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.552,31.236c-.256,0-.512-.098-.707-.293-.391-.391-.391-1.024,0-1.414l4.324-4.323c.391-.391,1.023-.391,1.414,0s.391,1.024,0,1.414l-4.324,4.323c-.195.195-.451.293-.707.293Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.912,
    y1: 35.126,
    x2: 34.394,
    y2: 35.126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.912,36.126h-16.518c-.552,0-1-.448-1-1s.448-1,1-1h16.518c.553,0,1,.448,1,1s-.447,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.753,
    y1: 39.695,
    x2: 34.43,
    y2: 35.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.753,40.695c-.256,0-.512-.098-.707-.293l-4.323-4.323c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l4.323,4.323c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.43,
    y1: 35.036,
    x2: 38.753,
    y2: 30.713
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,36.036c-.256,0-.512-.098-.707-.293-.391-.391-.391-1.023,0-1.414l4.323-4.323c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-4.323,4.323c-.195.195-.451.293-.707.293Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.912,70.921v17.615l-7.036-4.397v-11.526c-.222.008-.44.034-.665.034-.451,0-.893-.035-1.335-.067v11.56l-7.035,4.397v-17.938c-.694-.36-1.362-.759-2-1.202v20.943c0,.363.197.698.516.875.15.083.317.125.484.125.185,0,.368-.051.53-.152l8.505-5.315,8.506,5.315c.162.102.346.152.53.152.167,0,.334-.042.484-.125.318-.177.516-.512.516-.875v-20.51c-.641.405-1.308.768-2,1.091h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.211,73.647c-10.596,0-19.217-8.621-19.217-19.218s8.621-19.217,19.217-19.217,19.218,8.621,19.218,19.217-8.621,19.218-19.218,19.218ZM66.211,37.212c-9.493,0-17.217,7.724-17.217,17.217s7.724,17.218,17.217,17.218,17.218-7.724,17.218-17.218-7.724-17.217-17.218-17.217Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.048,48.371h-18.093c-.552,0-1,.447-1,1s.448,1,1,1h17.509c.156-.683.354-1.348.584-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.424,61.694c-.256,0-.512-.098-.707-.293l-5.453-5.453c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l4.746,4.746,9.534-9.534c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-10.241,10.241c-.195.195-.451.293-.707.293Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.037,55.284h-17.083c-.552,0-1,.447-1,1s.448,1,1,1h17.285c-.104-.656-.171-1.323-.202-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.751,62.197h-18.797c-.552,0-1,.447-1,1s.448,1,1,1h19.897c-.408-.64-.773-1.309-1.1-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionCertificate);
export default __webpack_public_path__ + "static/media/Transaction-Certificate.2a9697834862a11ba443baba40a12caa.svg";
export { ForwardRef as ReactComponent };